import React, { FC, useState } from 'react';
import {
  getHumanReadablePlannedPlannedTwinIDs,
  getPlannedTwinIDFilterOptions,
  getPlannedTwinIDTableByTwinIDKeyedByChanges,
} from '../../../../../selectors';
import {
  setPlannedTwinIDUpdateShowChangesOnly,
} from '../../../../../actions';
import PlannedTwinIDDiffTable from './PlannedTwinIDPropertiesDiffSubTable';
import { getContextStores } from '../../../../../context';
import UpdateToolExpandableTable from '../../../../../components/atoms/UpdateToolExpandableTable';

interface Props {
}

const PlannedTwinIDComparisonTable: FC<Props> = () => {
  /* Context */
  const contextStores = getContextStores();
  const {
    plannedTwinIDUpdateState,
    plannedTwinIDUpdateDispatch,
  } = contextStores;
  const {
    isPlanningPlannedTwinIDs,
    showChangesOnly,
  } = plannedTwinIDUpdateState || {};
  const tagFilterOptions = getPlannedTwinIDFilterOptions(contextStores);

  /* Selectors */
  const plannedTwinIDTableByTwinIDKeyedByChanges = getPlannedTwinIDTableByTwinIDKeyedByChanges(
    contextStores,
  );
  const updates = getHumanReadablePlannedPlannedTwinIDs(contextStores);
  const changes = plannedTwinIDTableByTwinIDKeyedByChanges;
  const isLoading = isPlanningPlannedTwinIDs;

  const [tagFilterValue, setTagFilterValue] = useState<string[]>([]);

  const getTableDataForComparison = () => {
    const filteredChanges = new Map();
    const filters = tagFilterValue.length ? tagFilterValue : tagFilterOptions;
    [...changes].forEach(([key, change]) => {
      if (filters.includes(key)) {
        filteredChanges.set(key, change);
      }
    });
    return updates?.filter((updatedPlannedTwinID) => {
      const plannedTwinIDKey = updatedPlannedTwinID.twinID;
      return filters.some(
        filter => [...(changes?.get(filter) ?? [])].includes(plannedTwinIDKey),
      );
    });
  };

  const expandedRowRender = record => (
    <PlannedTwinIDDiffTable record={record} />
  );
  const data = isPlanningPlannedTwinIDs ? [] : getTableDataForComparison();
  return (
    <UpdateToolExpandableTable
      isLoading={isLoading}
      dataIndex="twinID"
      data={data}
      expandedRowRender={expandedRowRender}
      onTagFilterChange={v => setTagFilterValue(v)}
      tagFilterValue={tagFilterValue}
      tagFilterOptions={tagFilterOptions}
      tagFilterChanges={changes}
      showChangesOnly={showChangesOnly}
      onShowChangesOnlyToggle={
        v => setPlannedTwinIDUpdateShowChangesOnly(v, plannedTwinIDUpdateDispatch)
      }
    />
  );
};

export default PlannedTwinIDComparisonTable;
